<template>
  <form>
    <v-text-field
      v-model="state.name"
      label="Name"
      outlined
      dense
      required
      :disabled="state.loading"
    ></v-text-field>
    <v-text-field
      v-model="state.businessId"
      label="Business ID"
      outlined
      dense
      required
      :disabled="state.loading"
    ></v-text-field>
    <v-text-field
      v-model="state.apiKey"
      label="API Key"
      outlined
      dense
      required
      type="password"
      :disabled="state.loading"
    ></v-text-field>

    <div class="align-center d-flex justify-end flex-column-reverse flex-sm-row flex-wrap">
      <v-btn
        :loading="state.loading"
        variant="elevated"
        color="grey"
        class="mt-4 mt-sm-0 w-100 w-sm-auto"
        :to="URLs.PAGE_CUSTOMER_EDIT(customerId)"
        text="Cancel"
      />
      <v-btn
        @click="handleClickSubmit"
        class="ml-0 ml-sm-2 w-100 w-sm-auto"
        color="primary"
        variant="elevated"
        :loading="state.loading"
        text="Submit"
      />
    </div>
  </form>
</template>
<script setup lang="ts">
import { Env, URLs } from "@/constants";
import { connectBirdEyeSourceSchema } from "@/schemas";
import { useAccountStore } from "@/stores/account";
import { IApp } from "@/types";
import { getAppEnv, makeAlert, validate } from "@/utils";
import { ref } from "vue";
import { useRouter } from "vue-router";

const accountStore = useAccountStore();
const router = useRouter();

const props = defineProps<{
  customerId: string;
  userId: string;
}>();

const state = ref<{
  businessId: string;
  apiKey: string;
  name: string;
  loading: boolean;
}>({
  businessId: "",
  apiKey: "",
  name: "",
  loading: false
});

const handleClickSubmit = async () => {
  const validated = validate(connectBirdEyeSourceSchema, {
    userId: props.userId,
    type: IApp.IFeedTypes.BirdEye,
    name: state.value.name,
    businessId: state.value.businessId,
    apiKey: state.value.apiKey,
    redirectUrl: Env.REDIRECT_URL,
    env: getAppEnv(),
    customerId: props.customerId
  });
  if (validated.status) {
    state.value.loading = true;
    const response = await accountStore.connectBirdEyeAccount(validated.data);
    if (response.status) {
      makeAlert(response.data.message, "success");
      router.push(URLs.PAGE_CUSTOMER_SOURCES(props.customerId));
    } else {
      makeAlert(response.message, "error");
    }
    state.value.loading = false;
  } else {
    makeAlert(validated.message, "error");
  }
};
</script>
